<template>
  <div>
    <div>
      <p class="ma-0 font-weight-medium">
        Cobertura manual
      </p>
      <p class="ma-0 mt-n1">
        <template v-if="detalhamento_categoria.cobertura_manual_categoria > 0">
          {{ `${Helpers.formatarValor(detalhamento_categoria.cobertura_manual_categoria)} dias` }}
        </template>

        <span v-else class="mr-1">Automática</span>

        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="500"
      content-class="bra-20"
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-card-title>
          <span>Cobertura de estoque manual</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3">
          <v-switch v-model="ativar_cobertura_manual" color="#a71830">
            <template #label>
              <span class="pl-2">Ativar cobertura manual</span>
            </template>
          </v-switch>

          <SysCategoriaMPPA
            v-model="categorias_selecionadas"
            label="Categorias onde a edição será feita"
            :qtde_visivel_selecionados="1"
            outlined
            clearable
            multiple
            :error-messages="getMensagensValidacao('categorias_selecionadas')"
          />

          <TextFieldFormatadorDeValor
            v-model="cobertura_manual_dias"
            outlined
            :max-digitos="0"
            label="Qtd. dias"
            suffix="dias"
            :disabled="!ativar_cobertura_manual"
            :error-messages="getMensagensValidacao('cobertura_manual_dias')"
            @focus="$event.target.select()"
            @keyup.enter="salvarCoberturaManual()"
          />
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="salvarCoberturaManual()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { required, minValue } from "vuelidate/lib/validators";
import { salvarCoberturaManual } from "@/api/compras/MateriaPrima";
import { logout } from "@/helpers";
import {mapGetters} from "vuex";
import SysCategoriaMPPA from "@/components/utils/crud/SysCategoriaMPPAAutocomplete";

export default {
  name: "CoberturaManual",
  components: {SysCategoriaMPPA, TextFieldFormatadorDeValor },
  props: {
    detalhamento_categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    ativar_cobertura_manual: false,
    categorias_selecionadas: [],
    cobertura_manual_dias: 0
  }),
  validations: {
    categorias_selecionadas: {required},
    cobertura_manual_dias: {
      required,
      minValue: minValue(0),
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'compraMateriaPrima/callbackAtualizarDetalhesCategoria',
    })
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        this.categorias_selecionadas = [this.detalhamento_categoria.idcategoria];
        this.cobertura_manual_dias = this.detalhamento_categoria.cobertura_manual_categoria;
        this.ativar_cobertura_manual = this.cobertura_manual_dias > 0;
      } else {
        setTimeout(() => {
          this.cobertura_manual_dias = 0;
          this.categorias_selecionadas = [];
          this.$v.$reset();
        }, 1000);
      }
    },
    ativar_cobertura_manual() {
      this.cobertura_manual_dias = this.ativar_cobertura_manual
        ? this.detalhamento_categoria.cobertura_manual_categoria
        : 0;
    }
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.minValue !== undefined) && !this.$v[campo].minValue) {
        return  ["Informe um valor maior."];
      }

      return [];
    },
    salvarCoberturaManual() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        categorias: this.categorias_selecionadas,
        cobertura_manual_dias: parseFloat(this.cobertura_manual_dias)
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarCoberturaManual(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.$emit('nova-cobertura-manual', this.cobertura_manual_dias)
            this.callbackAtualizarGridCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
